<template>
  <v-card>
    <v-card-title> Nastavení </v-card-title>
    <v-form v-if="settings" @submit.prevent="saveData">
      <v-card-text>
        <div>
          <v-row>
            <v-col cols="6">
              <v-text-field
                hide-details="auto"
                outlined
                filled
                dense
                v-model.number="settings.orderCommission"
                label="Vyska provizie (%)"
              ></v-text-field>
            </v-col>
            <v-card column>
              <v-container fluid>
                <v-row dense>
                  <v-col :cols="Number(6)">
                    <v-col>
                      <v-text-field
                        hide-details="auto"
                        outlined
                        filled
                        dense
                        v-model.number="
                          settings.defaultEstimate &&
                          settings.defaultEstimate.price
                        "
                        label="Price"
                      ></v-text-field>
                    </v-col>
                  </v-col>
                  <v-col :cols="Number(6)">
                    <v-col>
                      <v-text-field
                        hide-details="auto"
                        outlined
                        filled
                        dense
                        v-model.number="
                          settings.defaultEstimate &&
                          settings.defaultEstimate.duration
                        "
                        label="Duration"
                      ></v-text-field>
                    </v-col>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-col cols="6">
              <v-text-field
                hide-details="auto"
                outlined
                filled
                dense
                v-model.number="settings.hourPrice"
                label="Hodinová cena uklidu (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                hide-details="auto"
                outlined
                filled
                dense
                v-model.number="settings.detergentsPrice"
                label="Cena prostředků (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                hide-details="auto"
                outlined
                filled
                dense
                v-model.number="settings.orderCancellationPrice"
                label="Cena za zrušení úklidové služby (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  hide-details="auto"
                  outlined
                  filled
                  dense
                  v-model.number="settings.expressCleaningPrice"
                  label="Cena za expresní úklid (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  hide-details="auto"
                  outlined
                  filled
                  dense
                  v-model.number="settings.extraCleaningHourPrice"
                  label="Cena za přidanou hodinu úklidu (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  hide-details="auto"
                  outlined
                  filled
                  dense
                  v-model.number="settings.fixedFee"
                  label="Fixní částka k úklidu (CZK)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card-title class="mt-10"> Nastavení objektů </v-card-title>
          <v-row >
            <v-col
              v-for="align in settings.estimateConfiguration.slice(3, 6)"
              :key="JSON.stringify(align)"
            >
              <v-card class="pa-10 ma-1" outlined tile>
                <v-row>
                  <!-- <v-col>
                    <v-select
                      hide-details="auto"
                      label="Typ"
                      outlined
                      filled
                      dense
                      item-text="name"
                      item-value="code"
                      :items="serviceTypes"
                      v-model="align.cleaningTypeKey"
                    />
                  </v-col> -->
                  <v-col>
                    <v-select
                      hide-details="auto"
                      label="Velikost"
                      outlined
                      filled
                      dense
                      item-text="name"
                      item-value="code"
                      :items="dimensionalTypes"
                      v-model="align.objectSizeKey"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      hide-details="auto"
                      label="Doba trvání"
                      outlined
                      filled
                      dense
                      v-model.number="align.duration"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      hide-details="auto"
                      label="Cena"
                      outlined
                      filled
                      dense
                      v-model.number="align.price"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-card-title class="mt-10">Nastavení slev</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model="oneTimeOrderPercent"
                    label="Sleva na jednorázový úklid (%)"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model="weeklyOrderPercent"
                    label="Sleva na úklid každý týden (%)"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model="biweeklyOrderPercent"
                    label="Sleva na úklid každé dva týdny (%)"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model="monthlyOrderPercent"
                    label="Sleva na úklid každý měsíc (%)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn small color="primary" class="mx-1" type="submit">Uložit</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: "SettingsCard",
  data() {
    return {
      settings: null
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios.get("/v1/settings").then(({data}) => {
        this.settings = data;
      });
    },
    saveData() {
      const {
        blockedCreateNewCleaningServices,
        _id,
        updatedAt,
        createdAt,
        ...rest
      } = this.settings;
      this.axios.patch("/v1/settings", rest).then(()=>{
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      }).catch((el)=>{
        if (el.response && el.response.data && el.response.data.errors){
          el.response.data.errors.forEach((error)=>{
            this.$store.commit('addAlert', {
              type: 'error',
              message: error.message
            })
          })
        }else{
          this.$store.commit('addAlert', {
            type: 'error',
            message: "Chyba"
          })
        }
      })
    },
  },
  computed: {
    booleanSelectItems() {
      return [
        {
          text: "Ano",
          value: true,
        },
        {
          text: "Ne",
          value: false,
        },
      ];
    },
    serviceTypes() {
      return this.$store.state.types.serviceType;
    },
    dimensionalTypes() {
      return this.$store.state.types.dimensionType;
    },
    monthlyOrderPercent: {
      get() {
        return this.settings.discounts.monthlyOrderPercent || 0;
      },
      set(value) {
        this.$set(this.settings.discounts, 'monthlyOrderPercent', Number(value) || 0);
      },
    },
    biweeklyOrderPercent: {
      get() {
        return this.settings.discounts.biweeklyOrderPercent || 0;
      },
      set(value) {
        this.$set(this.settings.discounts, 'biweeklyOrderPercent', Number(value) || 0);
      },
    },
    oneTimeOrderPercent: {
      get() {
        return this.settings.discounts.oneTimeOrderPercent || 0;
      },
      set(value) {
        this.$set(this.settings.discounts, 'oneTimeOrderPercent', Number(value) || 0);
      },
    },
    weeklyOrderPercent: {
      get() {
        return this.settings.discounts.weeklyOrderPercent || 0;
      },
      set(value) {
        this.$set(this.settings.discounts, 'weeklyOrderPercent', Number(value) || 0);
      },
    }
  },
};
</script>

<style scoped>
</style>